exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1cbfa9c9] .el-dialog__body{max-height:650px;overflow:auto}\n", ""]);

// exports
